
export const back = window.location.origin+"/api";
export const client = true
